export const formatNumberWithK = (value: number, language: string = "en"): string => {
  if (!value) return "0";

  // Convert to string to count digits before decimal
  const numStr = Math.abs(value).toString();
  const wholeDigits = numStr.split(".")[0].length;

  const isArabic = language === "ar";
  const suffixes = {
    million: isArabic ? "مليون" : "M",
    thousand: isArabic ? "الاف" : "K",
  };

  if (wholeDigits >= 7) {
    // If 7+ digits, format as millions
    const formatted = (value / 1000000).toFixed(0);
    return isArabic ? `${formatted} ${suffixes.million}` : `${formatted}${suffixes.million}`;
  } else if (wholeDigits >= 4) {
    // If 4-6 digits, format as thousands
    const formatted = (value / 1000).toFixed(0);
    return isArabic ? `${formatted} ${suffixes.thousand}` : `${formatted}${suffixes.thousand}`;
  }

  // For numbers less than 1000, use locale-specific formatting
  return value.toLocaleString(language);
};
